export default __webpack_public_path__ + "static/media/white-logo.89ce6036.svg";